import { z } from 'zod';

/**
 * Environment variable schema with Zod validation
 */
const envSchema = z.object({
  REACT_APP_MAPBOX_TOKEN: z.string().optional(),
  REACT_APP_USER_POOL_ID: z.string().optional(),
  REACT_APP_CLIENT_ID: z.string().optional(),
  PUBLIC_URL: z.string().optional().default('/'),
});

/**
 * Get and validate environment variables
 * @returns Validated environment variables object
 * @throws Error if validation fails
 */
export function getEnv() {
  const metaEnv = import.meta.env;

  const localEnvModules = import.meta.glob<{ REACT_APP_MAPBOX_TOKEN?: string }>('./localEnv.ts', {
    eager: true,
  });
  const localEnv = Object.values(localEnvModules)[0] ?? {};

  const rawEnv = {
    REACT_APP_MAPBOX_TOKEN: metaEnv.REACT_APP_MAPBOX_TOKEN ?? localEnv.REACT_APP_MAPBOX_TOKEN,
    REACT_APP_USER_POOL_ID: metaEnv.REACT_APP_USER_POOL_ID,
    REACT_APP_CLIENT_ID: metaEnv.REACT_APP_CLIENT_ID,
    PUBLIC_URL: metaEnv.PUBLIC_URL,
    VITE_STRIPE_PUBLISHABLE_KEY: metaEnv.VITE_STRIPE_PUBLISHABLE_KEY,
  };

  return envSchema.parse(rawEnv);
}

/**
 * Validated environment variables
 */
export const env = getEnv();
